import {CircularProgress, Dialog, DialogContent} from '@mui/material'
import {StyledButton, StyledDialogActions, StyledErrorBox, StyledErrorInputLabel} from '../../SaveList/Styles'
import {StyledDiv, StyledDialogTitle} from './ConfirmationPopupStyles'
import PropTypes from 'prop-types'

const ConfirmationPopup = ({
  confirmationPopup,
  handleConfirmation,
  handleConfirmationClose,
  loading,
  errorMessage,
  name
}) => {
  return (
    <Dialog
      sx={{'& .MuiDialog-paper': {backgroundColor: (theme) => theme.palette.common.white, borderRadius: '10px'}}}
      maxWidth="md"
      open={confirmationPopup}
    >
      <StyledDialogTitle>Confirm delete</StyledDialogTitle>
      <DialogContent dividers>
        <StyledDiv bold={true} tabIndex="0">
          {'Do you want to delete '}
          {`'${name}' ?`}
        </StyledDiv>
        {errorMessage && (
          <StyledErrorBox>
            <StyledErrorInputLabel>{'Error occurred while removing prospect from list.'}</StyledErrorInputLabel>
          </StyledErrorBox>
        )}
      </DialogContent>
      <StyledDialogActions>
        <StyledButton disabled={loading} onClick={handleConfirmationClose}>
          Cancel
        </StyledButton>
        <StyledButton disabled={loading} onClick={handleConfirmation}>
          Confirm
        </StyledButton>
        {loading && <CircularProgress size="16px" />}
      </StyledDialogActions>
    </Dialog>
  )
}

ConfirmationPopup.propTypes = {
  confirmationPopup: PropTypes.bool,
  handleConfirmation: PropTypes.func,
  handleConfirmationClose: PropTypes.func,
  loading: PropTypes.bool,
  errorMessage: PropTypes.string,
  name: PropTypes.string
}

export default ConfirmationPopup
